import { MessageCircle } from 'lucide-react';
import { BRAND } from '@/data/mockData';
import { NAV } from '@/constants/testIds';

const FloatingWhatsApp = () => {
  return (
    <a
      href={BRAND.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid={NAV.floatingWhatsapp}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.45)] hover:scale-110 transition pulse-ring"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
};

export default FloatingWhatsApp;
